import React from 'react'
import Layout from './Layout'

export const ScanReports = () => <Layout />
